/**
 * язык человека. хранится только в профиле (user_profiles.locale), в
 * состояние матрицы не попадает: смена языка не трогает отметки.
 */
export const LOCALES = ['ru', 'en'];
export const DEFAULT_LOCALE = 'ru';
export function isLocale(v) {
    return typeof v === 'string' && LOCALES.includes(v);
}
//# sourceMappingURL=locale.js.map